export enum MenuType {
  LEFT_SIDEBAR = 2
}

export const MenuTypes = [
  {name: "Menu Sidebar", value: MenuType.LEFT_SIDEBAR},
];
